import { useTranslation } from 'react-i18next'

import BoldSpan from '../../../components/display/BoldSpan'
import { FAQItem } from '../../../components/landing/FAQ'
import { ComponentCTALink } from '../../../components/landing/display'

export const headerImage = {
  medium: {
    width: 620,
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/header/large-b3a9a3b1ab52f57dc9aba24eb77c7d0e.jpg',
  },
  large: {
    width: 1290,
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/header/large-b3a9a3b1ab52f57dc9aba24eb77c7d0e.jpg',
  },
  hero: {
    width: 1300,
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/header/large-b3a9a3b1ab52f57dc9aba24eb77c7d0e.jpg',
  },
}

export const headerText = {
  heading: 'Capture and share your adventures',
  subheading:
    'Escape into nature, get creative and inspire others to live fully.',
}

const TEMP_TEXT =
  'Cloud bread tote bag glossier, flannel synth narwhal hoodie pour-over adaptogen put a bird on it copper mug 3 wolf moon chia pok pok. Hot chicken sartorial slow-carb, ugh gluten-free hammock sriracha af.'

export const faqItems: FAQItem[] = [
  {
    title: 'How does Escape Builder work?',
    content: TEMP_TEXT,
  },
  {
    title: 'Who are Storytellers?',
    content: TEMP_TEXT,
  },
  {
    title: 'Can anyone share a story?',
    content: TEMP_TEXT,
  },
  {
    title: 'Can Riparide guarantee story content accuracy?',
    content: TEMP_TEXT,
  },
]

export const benefitsText = [
  {
    heading: 'Explore new places',
    text:
      'In the words of Dr Seuss – oh the places you’ll go! We’ll work with you to find accommodation and adventures that fit you and your crew like a glove.',
  },
  {
    heading: 'Creative freedom',
    text:
      'Enjoy the freedom to adventure and create content that fits your vibe. We keep our brief lean, so that you and your crew can actually enjoy your escape.',
  },
  {
    heading: 'The value of adventure',
    text:
      'We don’t expect our Storytellers to work for free, but a lot of the value of joining our community comes from the adventures you have and the people you meet. Get in touch with us to discuss the ways we compensate you for your work.',
  },
  {
    heading: 'Grow as a creative',
    text:
      'We’re here to help you connect with a community of like-minded storytellers, build industry connections and create a portfolio of varied content that you’re proud of.',
  },
  {
    heading: 'Inspire others',
    text:
      'Create work that will inspire other people to chase soul-fulfilling moments. Help make the world a better place, one outdoor adventure at a time.',
  },
]

export const benefitsImages = [
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/1/medium-24d2ee48017022de95b109767cac9d4f.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/1/large-4bb40f1f5532fa0ab06254b473b8a6cf.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/2/medium-f47e12640b0eb57a4f5f788fe62ff490.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/2/large-50f13bb1859510a2806ac94529ea3ce5.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/3/medium-66440a665ddf966c34434bfc2bb7c5c0.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/3/large-b1ae5772286b0e048f8a433aeafbb28c.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/4/medium-e7b797c0d6bb8eb68074e82dbcc6d0cf.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/4/large-ba03fbc375ba17dc3ed859c8b60ee560.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/5/medium-42f0210ecb44a424f3bc472c473e89dc.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/5/large-bea42033868784710e350bdb637cd3af.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/6/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/6/large.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/7/medium-d53e8d56e286929d4a43caca257a53a1.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/7/large-9bcc1a15e70f2690ab234348c03dd324.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/8/medium-7e18bae8e83d870f39760b0fad9e0bc2.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/8/large-b771bee76eca7a8b3f9d4a47ad5ea3ce.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/9/medium-1d395f0ff42e4fbb91314269d4b4c293.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/9/large-11fb359f4efc1bd177ee764bfe4707da.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/10/medium-3d754600eee2049bbfb3eaa7ed091fc9.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/10/large-903550213e9830f0c08bb6578608d59f.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/11/medium-f1cc7e11edd56a73584be7a36b0dace8.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/11/large-da0ae88dc0f14250ce330e7f5c907336.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/12/medium.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/12/large.jpg',
  },
]

export const benefitsPromoImage = {
  large: {
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/large_promo/large-7600b504f8663ec578d3f8b02da69508.jpg',
    width: 1300,
  },
  medium: {
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/benefits/large_promo/medium-3792f630067c75db0bd79588426df118.jpg',
    width: 620,
  },
}

export const standalonePromoImage = {
  hero: {
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/standalone_promo/hero-8f8ca2c7f612fbdf25c3efa0ec0c0f30.jpg',
    width: 1800,
  },
  large: {
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/standalone_promo/large-ceaab922dd8c9fe86104dd9506085ba7.jpg',
    width: 1050,
  },
  medium: {
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/standalone_promo/medium-d37349efaf7f02e50a2ed2b8227b198a.jpg',
    width: 620,
  },
}

export const howItWorksImage = {
  large: {
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/how_it_works/large-7bdf8d8d2cb145839bdcd7d6d5872470.jpg',
    width: 1300,
  },
  medium: {
    url:
      'https://assets.riparide.com/landing_pages/stories/storyteller/how_it_works/medium-1df76defb88a6ebe293d47fba07bbe2b.jpg',
    width: 620,
  },
}

export const storiesForCarousel = [
  {
    id: '85',
    url: '/stories/85-to-the-hills',
    title: 'To The Hills',
    promoImage: {
      large:
        'https://assets.riparide.com/story/85/promo_image/large-c38baf8cd185cdf4017c79768ee21dc3.jpg',
      hero:
        'https://assets.riparide.com/story/85/promo_image/hero-a5538fc9c1699f7adeb316a12c6a3c0c.jpg',
    },
    user: {
      id: '8691',
      firstName: 'Trent ',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/8691/avatar/thumb_lg-9a0f8dfb525d09968325bfe9c105a945.jpg',
      },
    },
  },
  {
    id: '152',
    url: '/stories/152-cosy-coastal-creatures',
    title: 'Cosy Coastal Creatures',
    promoImage: {
      large:
        'https://assets.riparide.com/story/152/promo_image/large-dbdc9a190086bbb99f659338519736ef.jpg',
      hero:
        'https://assets.riparide.com/story/152/promo_image/hero-ffe5ec4cb8e123bed1f28a816616ccb7.jpg',
    },
    user: {
      id: '5187',
      firstName: 'Kirk ',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/5187/avatar/thumb_lg-ceae894859eccb6bfd57c02815baac25.jpg',
      },
    },
  },
  {
    id: '77',
    url: '/stories/77-hee-hawing-around',
    title: 'Hee Hawing Around',
    promoImage: {
      large:
        'https://assets.riparide.com/story/77/promo_image/large-903550213e9830f0c08bb6578608d59f.jpg',
      hero:
        'https://assets.riparide.com/story/77/promo_image/hero-bf38cbc17564ec46783799c9416ebcce.jpg',
    },
    user: {
      id: '5187',
      firstName: 'Kirk ',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/5187/avatar/thumb_lg-ceae894859eccb6bfd57c02815baac25.jpg',
      },
    },
  },
  {
    id: '654',
    url: '/stories/654-back-in-time',
    title: 'Back in Time',
    promoImage: {
      large:
        'https://assets.riparide.com/story/654/promo_image/large-e86a1dc7eddedabd2ba89ab23e430b60.jpg',
      hero:
        'https://assets.riparide.com/story/654/promo_image/hero-bc5cc898c8870bfacf29a1fe735fdbed.jpg',
    },
    user: {
      id: '60700',
      firstName: 'Kadek',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/60700/avatar/thumb_lg-56bf6534e0e2d8dcfa65dd4f3ed6b087.jpg',
      },
    },
  },
  {
    id: '665',
    url: '/stories/665-beyond-the-highland-mist',
    title: 'Beyond the Highland Mist',
    promoImage: {
      large:
        'https://assets.riparide.com/story/665/promo_image/large-a152dd13a68211d0fd6907ce61bae00a.jpg',
      hero:
        'https://assets.riparide.com/story/665/promo_image/hero-58b9f58e2c88dc63eb901ed36446c26b.jpg',
    },
    user: {
      id: '60700',
      firstName: 'Kadek',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/60700/avatar/thumb_lg-56bf6534e0e2d8dcfa65dd4f3ed6b087.jpg',
      },
    },
  },
  {
    id: '607',
    url: '/stories/607-switching-off-at-wondernest',
    title: 'Switching off at Wondernest',
    promoImage: {
      large:
        'https://assets.riparide.com/story/607/promo_image/large-d0f662da2e472ea2add0b8e01cc97009.jpg',
      hero:
        'https://assets.riparide.com/story/607/promo_image/hero-24191ed21c714ed053f8f8a5ec67e0f4.jpg',
    },
    user: {
      id: '28362',
      firstName: 'Lucia',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/28362/avatar/thumb_lg-9d500a58b783eee2bfa9e077f36615ee.jpg',
      },
    },
  },
  {
    id: '604',
    url: '/stories/604-peaceful-parcel',
    title: 'Peaceful Parcel',
    promoImage: {
      large:
        'https://assets.riparide.com/story/604/promo_image/large-5e8fe2cd48f419b29c77cfe13c6b1ae9.jpg',
      hero:
        'https://assets.riparide.com/story/604/promo_image/hero-9122399f6fe339b265abf2dd760b6e4e.jpg',
    },
    user: {
      id: '7856',
      firstName: 'Alexandra',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/7856/avatar/thumb_lg-8f75cd65126d20a7aa7e8ef9ac87ebd8.jpg',
      },
    },
  },
  {
    id: '540',
    url: '/stories/540-out-by-the-orchard',
    title: 'Out By The Orchard',
    promoImage: {
      large:
        'https://assets.riparide.com/story/540/promo_image/large-8e03ea0d5586a119d999241b78683260.jpg',
      hero:
        'https://assets.riparide.com/story/540/promo_image/hero-53cf0ad15b3a73c6fffeac76677ad390.jpg',
    },
    user: {
      id: '12682',
      firstName: 'Liam & Alexis',
      avatar: {
        thumbLg:
          'https://assets.riparide.com/user/12682/avatar/thumb_lg-2c55c56e222fe9ad0b0108ce36e1cdc5.jpg',
      },
    },
  },
]

export const briefText = (
  <>
    <BoldSpan>Riparide Stories</BoldSpan> are real travel experiences captured
    and shared by our creative community of photographers, who we call
    Storytellers. Through inspiring photos, words and videos, our Storytellers
    bring our unique stays and local adventures to life.
    <br />
    <br />
    So grab your camera, rally the travel crew and join us on our mission to
    deliver soul-fulfilling escapes. One story at a time.
  </>
)

export const howItWorksText = [
  {
    heading: 'Join the community',
    text:
      'Hit us up with your content! Send us your portfolio! If we think you’re a good fit, we’ll welcome you to our storyteller community.',
  },
  {
    heading: 'Lock in your escape',
    text:
      'Our team will work with you to find the perfect Riparide property and region to suit your adventure style.',
  },
  {
    heading: 'Capture your experience',
    text:
      'It’s go-time. Read the brief, rally your crew and enjoy the freedom to explore, shoot and create your ultimate adventure.',
  },
  {
    heading: 'Share your story',
    text:
      'Upload your photos and words to Riparide.com and see your story come to life. It’s now a bookable – and most importantly, shareable – experience. Pat yourself on the back for inspiring others to live fully.',
  },
]

const ArianaTestimonialText = () => {
  const [t] = useTranslation('spelling')

  return (
    <>
      I love being able to explore new places and being part of a community of
      like-minded creators and {t('traveler')}s.
    </>
  )
}

const FabioTestimonialText = () => {
  const [t] = useTranslation('spelling')

  return (
    <>
      As a lifestyle and travel photographer, my goal is to generate value for
      my audience so when sharing on social media or my portfolio, I always pick
      images that will deliver not just aesthetically but also allow people to
      discover new places. Being a Riparide storyteller is like connecting those
      dots – there&apos;s no better place to find inspiration for{' '}
      {t('traveling')} and exploring our beautiful country.
    </>
  )
}

export const testimonials = [
  {
    name: 'Fabio',
    avatar: {
      thumb:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/5362/thumb.',
      thumbMd:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/5362/thumb_md.',
      thumbLg:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/5362/thumb_lg.',
    },
    text: <FabioTestimonialText />,
    CTA: <ComponentCTALink url="/users/5362">View Profile</ComponentCTALink>,
  },
  {
    name: 'Trent',
    avatar: {
      thumb:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/8691/thumb-2521eb802e99df1e194492d94b83d5c1.jpg',
      thumbMd:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/8691/thumb_md-be5fe6ed0e0cc5b6831868584c903514.jpg',
      thumbLg:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/8691/thumb_lg-9a0f8dfb525d09968325bfe9c105a945.jpg',
    },
    text:
      'I love being a storyteller for Riparide as it combines a few of my passions: appreciating great and unique architecture, seeing and creating beautiful memories that are documented through the stories we create, and meeting the hosts and hearing their stories. These stories inspired us to follow through with our own project – a converted bus called Gloria – an interest ignited by Riparide.',
    CTA: <ComponentCTALink url="/users/8691">View Profile</ComponentCTALink>,
  },
  {
    name: 'Lex',
    avatar: {
      thumb:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/7856/thumb-d910a0f550518100ddf47308db7b4380.jpg',
      thumbMd:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/7856/thumb_md-8c229cf723dcb6a8584efc0a36704ce6.jpg',
      thumbLg:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/7856/thumb_lg-8f75cd65126d20a7aa7e8ef9ac87ebd8.jpg',
    },
    text:
      'As a storyteller, an adventurer and a dreamer - my drive is to create purposeful and emotionally charged content, rooted in the belief that images speak to the soul of the viewer and are shaped by a passion for beauty, a heart for story, a search for connection, a desire for experience and thought-provoking content. While I acknowledge the value of aesthetics, I firmly believe that authentic storytelling is paramount.',
    CTA: <ComponentCTALink url="/users/7856">View Profile</ComponentCTALink>,
  },
  {
    name: 'Andrew & Jess',
    avatar: {
      thumb:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/267/thumb-8dfbb5da8d414ace0596686c3c32f700.jpg',
      thumbMd:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/267/thumb_md-13e5dae9e329dd0a8b20b7edc4cbaf2b.jpg',
      thumbLg:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/267/thumb_lg-e6ca6266826f4a5d7ad594479e28b76f.jpg',
    },
    text:
      "The Riparide crew has been awesome to work with and it's been a legendary experience getting to see parts of Australia I otherwise might not have. I started working with Riparide about 7 years ago and since then I've watched the idea combined with a passion for the outdoors and adventure grow into what we know as Riparide today. Thanks for having me along for the ride!",
    CTA: <ComponentCTALink url="/users/267">View Profile</ComponentCTALink>,
  },
  {
    name: 'Arianna',
    avatar: {
      thumb:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/4051/thumb-6123911593709e7537a4e788bf6e2719.jpg',
      thumbMd:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/4051/thumb_md-704d98a8820ac3f72ec889210aaffc44.jpg',
      thumbLg:
        'https://assets.riparide.com/landing_pages/stories/storyteller/testimonials/4051/thumb_lg-b25f2df069469ec9c8e544bcdcd850fd.jpg',
    },
    text: <ArianaTestimonialText />,
    CTA: <ComponentCTALink url="/users/4051">View Profile</ComponentCTALink>,
  },
]
